// boxy ui to display tag
// light blue background, blue text for positive
// light red background, red text for negative
import type { Tag as ITag } from '@baseball-near-you/prisma';
import { cn } from '../../utils';

export function Tag({ name, positive }: ITag) {
  return (
    <div
      className={cn(
        'w-min whitespace-nowrap rounded-md border px-2 py-0.5 font-medium text-sm',
        positive
          ? 'border-blue-500/[50%] bg-blue-50/[40%] text-blue-500'
          : 'border-red/[50%] bg-red/[7%] text-red'
      )}
    >
      {name}
    </div>
  );
}
